<script>
  import { Router, Route } from 'svelte-navigator'
  import WorkoutList from './workouts/WorkoutList.svelte'
</script>

<Router primary={false}>
  <Route path="/">
    <WorkoutList />
  </Route>
</Router>
